import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ImageSpotList",
    component: () => (__SERVER__ ? require("./image-spot-list-view") : import("./image-spot-list-view"))
});

export default definition;
